module.exports = __webpack_public_path__ + "static/media/29EUNOG1.75d08677.jpg";